(() => {
  if (window.nuoneoCartDrawerLoaded) return;
  window.nuoneoCartDrawerLoaded = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-upsell-add]');
    if (!form) return;

    event.preventDefault();
    const button = form.querySelector('.cart-upsell-button');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.labelAdding;

    try {
      const endpoint = form.action.endsWith('.js') ? form.action : `${form.action}.js`;
      const response = await fetch(endpoint, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Cart add failed');

      button.textContent = button.dataset.labelAdded;
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    } catch {
      button.textContent = button.dataset.labelError;
      button.removeAttribute('aria-busy');
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = button.dataset.labelDefault;
      }, 2000);
    }
  });
})();
